import {styled} from '../../utils';
import {padding} from 'polished';

export default styled('a')(({theme}) => ({
  fontFamily: theme.fontFamily.base,
  fontSize: theme.fontSize.base,
  cursor: 'pointer',
  ...padding(0, 8)
}));



// WEBPACK FOOTER //
// ./src/components/Tabs/Tab.tsx